const initialState = {
    selectedFollowup: null
}

const followupJobReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SELECTED_FOLLOWUP':
            return {
                selectedFollowup: action.followup
            }
        default:
            return state;
    }
}
export default followupJobReducer;